"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addContactSetStep = exports.AddContactStep = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
var AddContactStep;
(function (AddContactStep) {
    AddContactStep["SKIP"] = "SKIP";
    AddContactStep["EMAIL_SEND_CODE"] = "EMAIL_SEND_CODE";
    AddContactStep["EMAIL_AWAIT_CODE"] = "EMAIL_AWAIT_CODE";
    AddContactStep["PHONE_SEND_CODE"] = "PHONE_SEND_CODE";
    AddContactStep["PHONE_EXCHANGE_CODE"] = "PHONE_EXCHANGE_CODE";
})(AddContactStep = exports.AddContactStep || (exports.AddContactStep = {}));
exports.addContactSetStep = (0, toolkit_1.createAction)('ADD_CONTACT/SET_STEP');
